import React from "react";
import { ItemsMainProps } from "../type";
import LazyLoadImageComponent from "core/components/LazyLoadImage";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { nl2br } from "core/utils/helper";

const ThemeCard: React.FC<ItemsMainProps> = ({
  title,
  thumbnail,
  translates,
  flavor_items,
}) => {
  const { goToRecipeSuggession } = useRecipe()

  const handleClick = () => {
    goToRecipeSuggession(flavor_items.map((item: any) => String(item.id)), false)
    // goToRecipeSuggession([])
  }
  return (
    <div className="bg-[#00000062] mr-2 rounded-lg">
    <div
      className="flex relative flex-col pt-3 w-[140px] h-[180px]  text-white rounded-lg aspect-[0.727] bg-[#00000062]"
      onClick={handleClick}
    >
      <div className="rounded-lg ">
        <LazyLoadImageComponent
          alt={title}
          className="object-cover absolute w-full h-full inset-0 rounded-lg size-full to-black/70"
          src={thumbnail}
        />
      </div>
      <h3 className="
        absolute 
        top-0 
        pt-3 
        h-14 
        px-[5px] 
        w-full 
        self-start 
        text-[14px] 
        tracking-tighter  
        rounded-lg 
        bg-gradient-to-t 
        from-transparent 
        to-black/70 
        text-center
        font-medium"
        dangerouslySetInnerHTML={{
          __html: nl2br(translates[0].title),
        }}
      >
      </h3>
      <p 
        className="
        absolute 
        bottom-0 
        pb-[12px] 
        h-14 
        inset-x-0 
        tracking-tighter 
        text-center  
        rounded-lg 
        bg-gradient-to-b 
        from-transparent 
        to-black/70 
        text-[13px] 
        flex 
        items-end 
        justify-center 
        px-[6px] 
        font-normal"
        dangerouslySetInnerHTML={{
          __html: nl2br(translates[0].description),
        }}
        >
      </p>
    </div>
    </div>
  );
};
/* Rectangle 3835 */

export default ThemeCard;
